import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {of} from 'rxjs/internal/observable/of';
import {catchError, map} from 'rxjs/operators';
import {Observable} from 'rxjs/internal/Observable';

@Injectable({providedIn: 'root'})
export class PermissionsService {

    constructor(private authService: AuthService, private router: Router) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> {
        return this.authService.loadSession().pipe(
            map(() => true),
            catchError(() =>
                of(
                    this.router.createUrlTree(['/login'], {
                        queryParams: { returnUrl: state.url }
                    })
                )
            )
        );
    }
}

export const AuthGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    return inject(PermissionsService).canActivate(route, state);
};
